export const STATUS_FILTER_OPTIONS = [
    { label: 'status.all', value: 'all' },
    { label: 'status.current', value: 'current' },
    { label: 'status.closed', value: 'closed' },
    { label: 'status.redeemed', value: 'redeemed' },
    { label: 'status.cancelled', value: 'cancelled' },
    { label: 'status.declined', value: 'declined' }
];
